import { useEffect } from 'react';
import { Page } from '../../Page';
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setPromptOkCancelOnHome } from '../menu/menuSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectCurrentPartyEvent, setStartDate } from '../currentPartyEvent/currentPartyEventSlice';
import { useNavigate } from 'react-router-dom';
import styles from './Wizard.module.css'
import { setMessage } from '../messageBoxes/messageBoxSlice';
import { DateTimePicker } from '../../components/DateTimePicker';
import { BackButton } from '../menu/BackButton';

export function CreateDate() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setPromptOkCancelOnHome(true))
        dispatch(setMessage('Cancel saving this event and return to the home page?'))
    })
    return(
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.header}>
                <div className={styles.dateTimerPicker}>
            <DateTimePicker nullDescription="Slide toggle if you don't want to set date or time yet" transmissionDateTime={currentPartyEvent?.start} dateDescription='What date will the party be on' timeDescription='Now, what time will your party start?' dateLabel='' timeLabel = ''
                onDateChange={(e) => {
                    dispatch(setStartDate(e ?? ''))
                }}
            />
            </div>
            </div>
            
            <br></br>
            <div className={styles.controlButtons}>
            <button className={styles.skipButton} onClick={() => {
                navigate('/Location')
                }}>Skip</button>

                <button className={styles.saveButton}  onClick={() => {
                    navigate('/Location')
                    }}>Next 
                </button>
                <br></br>
                </div>
         </Page>
    )
}